import { useIntercom } from 'react-use-intercom';

import asBentoPage from 'common/bento/hoc/asBentoPage';
import Button from 'components/_core/Button';
import Callout from 'components/_core/Callout';
import Text from 'components/_core/Text';
import OBNavigation from 'features/Onboarding/components/OBNavigation/OBNavigation';

import Header from '../../../../components/Header';
import CapitalDepositQuestionPage from '../../components/QuestionPage';
import { CapitalDepositPage } from '../../types';
import locales from './locales';

type CapitalDepositCertificateWarningProps = {
  isSending: boolean;
  onNext: () => void;
  isMandatee: boolean;
} & CapitalDepositPage;

const CapitalDepositCertificateWarning =
  asBentoPage<CapitalDepositCertificateWarningProps>(
    ({ isMandatee, isSending, Layout, onNext, onPrev, progress }) => {
      const intercom = useIntercom();

      return (
        <Layout nav={<OBNavigation onPrev={onPrev} />}>
          <CapitalDepositQuestionPage
            button={
              <Button icon="arrow-right" isLoading={isSending} onClick={onNext}>
                {locales.ctaButton}
              </Button>
            }
            progress={progress}
          >
            <Header title={locales.title} />

            <Callout variant="warning">
              <Callout.Content>{locales.warning}</Callout.Content>
            </Callout>

            {!isMandatee ? (
              <>
                <Text marginTop="space-24">
                  {locales.descriptionForNonMandatee}
                </Text>
                <Text fontWeight="weight-500" marginTop="space-24">
                  {locales.priceInfo}
                </Text>
                <Button
                  marginTop="space-26"
                  onClick={() => intercom.show()}
                  variant="inline-secondary"
                >
                  {locales.askForHelp}
                </Button>
              </>
            ) : null}
          </CapitalDepositQuestionPage>
        </Layout>
      );
    },
  );

export default CapitalDepositCertificateWarning;
